export const environment = {
  production: false,
  staging: true,
  apiUrl: 'https://api-conti.miclickderecho.com/autoser-staging',
  appName: 'AUTOSER - Staging',
  version: '1.0.0-staging',
  tenant: 'autoser',
  academyName: 'CEA AUTOSER',
  academyFullName: 'Centro de Enseñanza Automovilística AUTOSER S.A.S',
  logo: 'assets/img/logo-autoser.png',
  supportEmail: 'escuelaautoser@outlook.es',
  primaryColor: '#1e40af',
};
